import { render, staticRenderFns } from "./MainSite.vue?vue&type=template&id=2688b660&scoped=true&"
import script from "./MainSite.vue?vue&type=script&lang=js&"
export * from "./MainSite.vue?vue&type=script&lang=js&"
import style0 from "./MainSite.vue?vue&type=style&index=0&id=2688b660&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2688b660",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2688b660')) {
      api.createRecord('2688b660', component.options)
    } else {
      api.reload('2688b660', component.options)
    }
    module.hot.accept("./MainSite.vue?vue&type=template&id=2688b660&scoped=true&", function () {
      api.rerender('2688b660', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MainSite.vue"
export default component.exports